<template>
  <div class="e-chat__wrapper">
    <e-chat-message
      v-for="message in messages"
      :key="message.id"
      :subject="message.subject"
      :type="message.type"
      :id="message.id"
      :message="message.message">
    </e-chat-message>
  </div>
</template>

<script>
	import EChatMessage from "./message";
  export default {
		name: "e-chat",
    components: {EChatMessage},
    data() {
		  const subjects = [
        { avatar: 'https://randomuser.me/api/portraits/men/10.jpg' },
        { avatar: 'https://randomuser.me/api/portraits/men/11.jpg' },
      ];

		  return {
        messages: [
          {
            id: 1,
            subject: subjects[0],
            type: 'from',
            message: {
              text: 'You account is now varified. Feel free connect your wallet and start trading & rating',
              date: Date.now(),
            }
          },
          {
            id: 2,
            subject: subjects[1],
            type: 'to',
            message: {
              text: 'You completed your varification and waiting for an approval...',
              date: Date.now() - 1000 * 60 * 5,
            }
          },
          {
            id: 3,
            subject: subjects[1],
            type: 'to',
            message: {
              text: 'You rated IOTA for +25%',
              date: Date.now() - 1000 * 60 * 60,
            }
          },
          {
            id: 4,
            subject: subjects[0],
            type: 'from',
            message: {
              text: 'New bit by <span>@Fredric</span> for Wings',
              date: Date.now() - 1000 * 60 * 120,
            }
          },
          {
            id: 5,
            subject: subjects[0],
            type: 'from',
            message: {
              text: 'You account is now varified. Feel free connect your wallet and start trading & rating',
              date: Date.now() - 1000 * 60 * 24 * 60,
            }
          }
        ]
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/chat/chat.vue